module.exports = __webpack_public_path__ + "static/media/homem_r1_c4.79cb3b26.jpg";